//@flow
import React from "react";

export type barIndicatorType = {
  max: number,
  total: number,
  color: string,
  suffix?: string,
};

export default function barIndicator({
  max,
  total,
  color = "rgba(255, 221, 180, 1)",
  suffix,
}: barIndicatorType) {
  const totalAsPercentileOfMax = (100 / max) * total;
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center  h-100 w-100"
      style={{
        minWidth: "100px",
        background: `linear-gradient(to right, ${color}, ${totalAsPercentileOfMax}%, white 1%)`,
      }}
    >
      <div className="indicator-text">{`${total || 0}${suffix || ""}`}</div>
    </div>
  );
}
